import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

export type FactMapping = {
  factName: string;
  factLabels?: Record<string, string>;
  consumerKey?: string;
  isSingleFact?: boolean;
};

export const getFactMappingValues = ({
  facts,
  outputKeys,
  factMappings,
  valueKey = 'value',
}: {
  facts: PlotReportFactElement[];
  outputKeys: string[];
  factMappings: FactMapping[];
  valueKey?: string;
}) => {
  return factMappings
    .map((factMapping) => {
      const factValue = extractFactMappingValue({ facts, factMapping });

      if (isNullish(factValue)) {
        return null;
      }

      return {
        [valueKey]: factValue,
        ...outputKeys.reduce(
          (acc, key) => {
            acc[`${key}`] = key in factMapping ? factMapping?.[key as keyof FactMapping] : undefined;
            return acc;
          },
          {} as Record<string, FactMapping[keyof FactMapping]>,
        ),
      };
    })
    .filter(Boolean);
};

export const extractFactMappingValue = ({
  facts,
  factMapping,
}: {
  facts: PlotReportFactElement[];
  factMapping: FactMapping;
}) => {
  const fact = getFactFromFactArray(facts, factMapping.factName, factMapping.factLabels);
  if (isNullish(fact)) {
    return null;
  }

  const factValue = Array.isArray(fact.value) ? fact.value[0]?.value : fact.value;
  if (isNullish(factValue)) {
    return null;
  }

  return factValue;
};
